import {
  Drawer,
  IconButton,
  Icon,
  Box,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";
import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";
import MDTypography from "theme/components/MDTypography";

function CallHistoryPage({ open, onClose, calls, onSelectContact }) {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100vw",
          maxWidth: "100vw",
          left: 0,
          right: 0,
          margin: 0,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,

          height: "auto",
          minHeight: "40vh",
          maxHeight: "85dvh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <MDBox p={2} display="flex" flexDirection="column" height="100%">
        <MDBox display="flex" justifyContent="space-between">
          <MDBox>
            <MDTypography variant="h6">Call History</MDTypography>
          </MDBox>
          <MDBox mt={-1}>
            <MDButton
              size="small"
              variant="outlined"
              color="dark"
              iconOnly
              circular
              onClick={onClose}
            >
              <Icon>close</Icon>
            </MDButton>
          </MDBox>
        </MDBox>
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            mt: 2.5,
          }}
        >
          {calls.length > 0 ? (
            <MDBox>
              {calls.map((call) => (
                <MDBox mb={2}>
                  <ListItem
                    divider
                    onClick={() => {
                      if (call.direction === "inbound") {
                        return;
                      }
                      const contact = {
                        name: call.name,
                        phone_number: call.phone_number,
                      };
                      onSelectContact?.(contact);
                      onClose();
                    }}
                  >
                    <ListItemText
                      primary={
                        <MDTypography
                          variant="body2"
                          fontWeight="regular"
                          fontSize={14}
                        >
                          {call.name}
                        </MDTypography>
                      }
                      secondary={
                        <MDTypography variant="body2" fontSize={13}>
                          {call.created}
                        </MDTypography>
                      }
                    />
                    <MDBox>
                      <Icon
                        color={
                          call.direction === "inbound" ? "warning" : "success"
                        }
                      >
                        {call.direction === "inbound"
                          ? "phone_callback"
                          : "phone_forwarded"}
                      </Icon>
                    </MDBox>
                  </ListItem>
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <MDBox align="center">
              <MDTypography variant="body2" fontSize={48}>
                <Icon>phone_disabled</Icon>
              </MDTypography>
              <MDTypography variant="body2" fontSize={14}>
                You have not made or received any calls.
              </MDTypography>
            </MDBox>
          )}
        </Box>
      </MDBox>
    </Drawer>
  );
}

export default CallHistoryPage;
